(function () {
  'use strict';

  // Esegui solamente sulla versione inglese del negozio.
  if (!window.location.pathname.startsWith('/en/')) {
    return;
  }

 const translations = {
  'Le tue Iniziali (fronte)': 'Your initials (front)',
  'Le tue iniziali': 'Your initials',
  'Inserisci le tue iniziali (max 10 caratteri)': 'Enter your initials (max 10 characters)',
  'La tua dedica (retro)': 'Your dedication (back)',
  'La tua dedica': 'Your dedication',
  'Pergamena scritta a mano': 'Handwritten card',
  'Biglietto dedicato': 'Dedicated card'
};

  function translatePodifai() {
    const container = document.querySelector('#podifai-product-options-app');

    if (!container) {
      return;
    }

    /*
     * 1. Titoli delle opzioni
     *
     * Esempio:
     * Le tue Iniziali (fronte)
     * → Your initials (front)
     */
    container
      .querySelectorAll('.podifai-is-option-title')
      .forEach(function (element) {

        const original = element.textContent.trim();

        if (translations[original]) {
          element.textContent = translations[original];
        }
      });


    /*
     * 2. Valori delle opzioni
     *
     * Manteniamo separato il prezzo:
     *
     * Le tue iniziali (+€20,00)
     * → Your initials (+€20,00)
     */
    container
      .querySelectorAll('.podifai-bg-list-title')
      .forEach(function (element) {

        const text = element.textContent.trim();

        for (const original in translations) {

          if (text.startsWith(original)) {

            const translated = translations[original];

            // Cerchiamo il primo nodo di testo.
            for (const node of element.childNodes) {

              if (node.nodeType === Node.TEXT_NODE) {

                node.textContent = translated + ' ';
                break;
              }
            }

            break;
          }
        }
      });


    /*
     * 3. Placeholder dei campi di testo
     */
    container
      .querySelectorAll('input[placeholder], textarea[placeholder]')
      .forEach(function (element) {

        const original = element.getAttribute('placeholder');

        if (translations[original]) {
          element.setAttribute(
            'placeholder',
            translations[original]
          );
        }
      });
  }


  /*
   * Prima esecuzione.
   */
  translatePodifai();


  /*
   * Podifai può aggiornare dinamicamente il proprio DOM.
   *
   * L'observer permette quindi di riapplicare le traduzioni
   * quando l'utente seleziona/cambia un'opzione.
   */
  let timeout = null;

  const observer = new MutationObserver(function () {

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      translatePodifai();
    }, 50);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();